import { Stack, Typography } from "@mui/material";
import { ReactNode, useState } from "react";
import { ManageFields, ManageSectionsModals } from "../../types/enums";
import { ConfigSectionModal } from "./modal";
import { useParams } from "react-router-dom";

export const ManageSectionsBlock = ({
  adjustSection,
  manageSections,
  hidePrevModalHandler,
  closePrevModalHandler,
  modal,
}: {
  adjustSection: string;
  manageSections: string;
  hidePrevModalHandler: (isHide: boolean) => void;
  closePrevModalHandler: () => void;
  modal: ManageSectionsModals;
}) => {
  const { campaign_id } = useParams();
  const [currentModal, setCurrentModal] = useState<ManageSectionsModals>(
    ManageSectionsModals.none,
  );

  const onBackHandler = () => {
    hidePrevModalHandler(false);
    setCurrentModal(ManageSectionsModals.none);
  };

  const modals: Record<ManageSectionsModals, ReactNode> = {
    [ManageSectionsModals.account_plan]: (
      <ConfigSectionModal
        type={ManageFields.account_plan_fields}
        campaign_id={campaign_id!}
        onClose={closePrevModalHandler}
        onBack={onBackHandler}
      />
    ),
    [ManageSectionsModals.playbook]: (
      <ConfigSectionModal
        type={ManageFields.sdr_playbook_fields}
        campaign_id={campaign_id!}
        onClose={closePrevModalHandler}
        onBack={onBackHandler}
      />
    ),
    [ManageSectionsModals.none]: null,
  };

  const manageSectionHandler = () => {
    setCurrentModal(modal);
    hidePrevModalHandler(true);
  };

  return (
    <Stack gap={"8px"} alignItems="flex-start" paddingBottom={"8px"}>
      <Typography
        component="span"
        variant="subtitle1"
        sx={{ color: "#464646" }}
      >
        Adjust which sections are included in the {adjustSection}:
      </Typography>
      <Typography
        component="span"
        variant="subtitle1"
        sx={{
          color: "#496389",
          textDecoration: "underline",
          cursor: "pointer",
        }}
        onClick={manageSectionHandler}
      >
        Manage {manageSections} Sections
      </Typography>
      {modals[currentModal]}
    </Stack>
  );
};
